








































import { Component, Vue, Watch } from 'vue-property-decorator';
import SBProTopNav from '@structural/top-nav.vue';
import SBProPageHeader from '@structural/page-header.vue';
import SBProLayoutDefault from '@structural/layout-default.vue';
import SBProPageSection from '@structural/page-section.vue';

export interface FormErrors {
    [index: string]: string[];
}

@Component({
    components: {
        'sbpro-top-nav': SBProTopNav,
        'sbpro-page-header': SBProPageHeader,
        'sbpro-layout-default': SBProLayoutDefault,
        'sbpro-page-section': SBProPageSection,
    },
})
export default class LeadCapture extends Vue {
    errors: FormErrors = {
        firstName: [],
        lastName: [],
        email: [],
        company: [],
    };

    firstName: string | null = null;
    lastName: string | null = null;
    email: string | null = null;
    company: string | null = null;

    onSubmit(event: Event) {
        if (!this.firstName) {
            this.firstName = '';
            this.errors.firstName.push('required');
        }
        if (!this.lastName) {
            this.lastName = '';
            this.errors.lastName.push('required');
        }
        if (!this.email) {
            this.email = '';
            this.errors.email.push('required');
        } else if (!this._validEmail(this.email)) {
            this.errors.email.push('email');
        }
        if (!this.company) {
            this.company = '';
            this.errors.company.push('required');
        }

        this.emailValid;
        this.emailInvalid;

        if (!this.hasErrors()) {
            // Do something here, or add action and method to form
            event.preventDefault();
            this.$bvModal.show('modal-1');
            return true;
        }

        return event.preventDefault();
    }

    @Watch('firstName')
    onFirstNameChange() {
        this.errors.firstName = [];
        if (!this.firstName) {
            this.errors.firstName.push('required');
        }
    }

    @Watch('lastName')
    onLastNameChange() {
        this.errors.lastName = [];
        if (!this.lastName) {
            this.errors.lastName.push('required');
        }
    }

    @Watch('email')
    onEmailChange() {
        this.errors.email = [];
        if (!this.email) {
            this.errors.email.push('required');
        } else if (!this._validEmail(this.email)) {
            this.errors.email.push('email');
        }
    }

    @Watch('company')
    onCompanyChange() {
        this.errors.company = [];
        if (!this.company) {
            this.errors.company.push('required');
        }
    }

    hasError(key: string, error: string): boolean {
        return !!this.errors[key].find(e => e === error);
    }

    _validEmail(email: string) {
        const re = RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );
        return re.test(email);
    }

    hasErrors(): boolean {
        for (const key in this.errors) {
            if (this.errors[key].length > 0) {
                return true;
            }
        }
        return false;
    }

    get emailValid(): boolean {
        return this.email !== null && !this.emailInvalid;
    }

    get emailInvalid(): boolean {
        return (
            this.email !== null &&
            (this.hasError('email', 'required') ||
                this.hasError('email', 'email'))
        );
    }

    get firstNameValid(): boolean {
        return this.firstName !== null && !this.firstNameInvalid;
    }

    get firstNameInvalid(): boolean {
        return (
            this.firstName !== null && this.hasError('firstName', 'required')
        );
    }

    get lastNameValid(): boolean {
        return this.lastName !== null && !this.lastNameInvalid;
    }

    get lastNameInvalid(): boolean {
        return this.lastName !== null && this.hasError('lastName', 'required');
    }

    get companyValid(): boolean {
        return this.company !== null && !this.companyInvalid;
    }

    get companyInvalid(): boolean {
        return this.company !== null && this.hasError('company', 'required');
    }
}
